module.exports = __webpack_public_path__ + "58765b4ec1b4b4ad5d97595fee4bda2a.svg";